import { useDispatch, useSelector } from "react-redux"
import AnimatedPage from "../components/animatedPage"
import Banner from "../components/banner/banner"
import Cards from "../components/students/cards"
import { useEffect } from "react"
import { fetchStudentHubData } from "../redux/slice/studentHubPage"
import { retrunAssets } from "../utils/getAssets"
import { Outlet } from "react-router-dom"



const Students = () => {



    const dispatch = useDispatch()
    const state = useSelector(state => state.studentHub)


    useEffect(() => {
        dispatch(fetchStudentHubData("student-hub"))
    }, [dispatch])

    const students = state?.data?.properties
    const text = students?.title
    const bg = students?.backgroundImage != null ? retrunAssets(students?.backgroundImage[0]?.url) : ""
    const quicAccess = students?.quickAccess?.items?.map((item) => {
        item = item?.content?.properties
        return {
            title: item?.label,
            buttonLabel: item?.buttonLabel,
            buttonLinkURL: item?.buttonLinkURL,
            img: item?.image != null ? retrunAssets(item?.image[0]?.url) : "",
        }
    })

    return (
        <AnimatedPage>
            <Banner text={text} bg={bg} />
            <Cards cards={quicAccess} />

        </AnimatedPage>
    )
}

export default Students